import Swiper, {Navigation, Pagination} from "swiper";
import resize from "../../utils/resize";
Swiper.use([Navigation, Pagination]);

const initClassesSlider = () => {
  const sliderContainer = document.querySelector("[data-classes-slider]");
  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(sliderContainer, {
        spaceBetween: 8,

        breakpoints: {
          997: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 2,
          },
        },
        pagination: {
          el: "[data-classes-slider-container] .swiper-pagination",
          clickable: true,
          bulletElement: "button",
        },
        navigation: {
          nextEl: "[data-classes-slider-container] .slider-navigation__button--next",
          prevEl: "[data-classes-slider-container] .slider-navigation__button--prev",
        },
      });
    }
  }

  function destroy() {
    if (swiper) {      
      swiper.destroy();
      swiper = null;
    }
  }

  function resizeSwiper () {
    window.innerWidth > 767
      ? init()
      : destroy();
  }
  
  sliderContainer && resizeSwiper();
  sliderContainer && resize(resizeSwiper);
};

export default initClassesSlider;
